'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["fieldKey", "value", "onChange", "debouncedLoadOptions", "required"];
import AsyncSelector from 'ContentComponents/cmv2/components/AsyncSelector';
import { jsx as _jsx } from "react/jsx-runtime";
const FormSelectorSelect = props => {
  const {
      fieldKey,
      value,
      onChange,
      debouncedLoadOptions,
      required
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(AsyncSelector, Object.assign({}, rest, {
    value: value,
    onChange: onChange,
    loadOptions: debouncedLoadOptions,
    "data-selenium": `${fieldKey}:formSelect`,
    clearable: !required
  }));
};
export default FormSelectorSelect;